import { createContext } from '../utils'

export interface ButtonContextValue {
  disabled?: boolean
  size?: string
  variant?: string
  intent?: string
  isDropDown?: boolean
  hasTextContent?: boolean
  isLoading?: boolean
}

const [ButtonProvider, useButtonContext] = createContext<ButtonContextValue>({ isOptional: true })

export { ButtonProvider, useButtonContext }
